/**
* 用户管理 用户列表
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <!-- :to="{ path: '/' }" -->
      <el-breadcrumb-item>轮播图管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <div style="float: right;margin-right:2%;">
      <el-button style='margin: 10px 0;margin-right: 20px;' size="mini" type="primary" icon="document"
        @click="dataSelect">刷新</el-button>
      <!-- <el-button style='margin: 10px 0;' size="mini" type="primary"
            icon="document" @click="addNotice">新增</el-button>  @click="addNotice"-->
      <!-- <el-button style='margin: 10px 0;' size="mini" type="primary"
            icon="document"><el-upload class="avatar-uploader" v-model="img"
             action="https://api.weipaidui.xyz/app-yijiu-backstage/backUpload" :show-file-list="false"
             :on-success="handleAvatarSuccess">新增</el-upload></el-button> -->

      <!-- <img v-if="img" :src="img" class="avatar"
              style="border-radius: 6px;width: 148px;height: 148px;" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
      <el-button style='margin: 10px 0;margin-right: 20px;' size="mini" type="primary" icon="document"
        @click="addNotice()">新增</el-button>
    </div>

    <el-table style="width:100%" border v-loading="tableDataLoading" :data="tableData" row-key="id"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <!-- <el-table-column  prop="id" label="编号" width="80">
			</el-table-column> -->
      <el-table-column prop="url" label="轮播图网址">
      </el-table-column>
      <el-table-column prop="jumpUrl" label="跳转路径">
      </el-table-column>
      <el-table-column prop="webPage" label="所属页面">
      </el-table-column>
      <el-table-column prop="type" label="类型">
      </el-table-column>
      <el-table-column width="120px" high="100px" prop="url" label="预览">
        <template slot-scope="scope">
          <el-image style="width: 100px; height: 100px" :src="scope.row.url" :preview-src-list="[scope.row.url]">
          </el-image>
        </template>
      </el-table-column>
      <!-- <el-table-column width="150px" prop="createTime"  label="创建时间">
			</el-table-column> -->

      <el-table-column label="操作" width="120px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary"
						@click="updateNotice(scope.row)">修改
					</el-button>
          <el-button size="mini" type="danger" @click="deletes(scope.row.id)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="添加轮播图" :visible.sync="dialogFormVisible" center>

      <div style="margin-bottom: 10px;display:flex;">
        <span style="width: 200px;display: inline-block;text-align: right;">图片：</span>
        <div
          style=" width:148px;height:148px;border: 1px dashed #c0ccda;border-radius: 6px;text-align: center;line-height: 148px;">
          <el-upload class="avatar-uploader" v-model="addForm.url"
            action="https://api.weipaidui.xyz/app-yijiu-backstage/backUpload" :show-file-list="false"
            :on-success="handleAvatarSuccess">
            <img v-if="addForm.url" :src="addForm.url" class="avatar"
              style="border-radius: 6px;width: 148px;height: 148px;" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>

      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">跳转路径：</span>
        <el-input style="width:50%;" v-model="addForm.jumpUrl" placeholder="请输入跳转路径"></el-input>
      </div>

      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">所属页面：</span>
        <el-input style="width:50%;" v-model="addForm.webPage" placeholder="请输入所属页面"></el-input>
      </div>

      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">类型：</span>
        <el-input style="width:50%;" v-model="addForm.type" placeholder="请输入类型"></el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addCarousel()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改轮播图" :visible.sync="dialogFormVisible1" center>

      <div style="margin-bottom: 10px;display:flex;">
        <span style="width: 200px;display: inline-block;text-align: right;">图片：</span>
        <div
          style=" width:148px;height:148px;border: 1px dashed #c0ccda;border-radius: 6px;text-align: center;line-height: 148px;">
          <el-upload class="avatar-uploader" v-model="updateForm.url"
            action="https://api.weipaidui.xyz/app-yijiu-backstage/backUpload" :show-file-list="false"
            :on-success="handleAvatarSuccess2">
            <img v-if="updateForm.url" :src="updateForm.url" class="avatar"
              style="border-radius: 6px;width: 148px;height: 148px;" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>

      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">跳转路径：</span>
        <el-input style="width:50%;" v-model="updateForm.jumpUrl" placeholder="请输入跳转路径"></el-input>
      </div>

      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">所属页面：</span>
        <el-input style="width:50%;" v-model="updateForm.webPage" placeholder="请输入所属页面"></el-input>
      </div>

      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">类型：</span>
        <el-input style="width:50%;" v-model="updateForm.type" placeholder="请输入类型"></el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="updateCarousel()">确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import { addCarousel, deleteCarousel, getCarouselList , updateCarousel} from '../../../api/manage/carousel.js'
import moment from 'moment';

export default {
  data() {
    return {
      img: '',
      multipleSelection: [],
      totalnum: 0,
      page: 1,
      size: 10,
      tableDataLoading: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      tableData: [],
      addForm: {
        url: '',
        type: '',
        jumpUrl: '',
        webPage: ''
      },
      updateForm: {
        id:'',
          url: '',
          type: '',
          jumpUrl: '',
          webPage: '',
          createTime:''
      },

    }
  },
  components: {

  },

  created() {
    this.dataSelect()
    // this.getdata(1)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    handleAvatarSuccess(file) {
      this.addForm.url = file.msg;
      // console.log("file.data======",file.msg)
    },

    handleAvatarSuccess2(file) {
      this.updateForm.url = file.msg;
      // console.log("file.data======",file.msg)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    updateCarousel(file) {

      // let obj = {
      //   url:file,
      // }
      let obj = this.updateForm
      updateCarousel(obj).then(res => {
        this.$message({
          type: "success",
          message: res.msg,
          duration: 1500,
          onClose: () => {
            this.dialogFormVisible1 = false
            this.dataSelect()
          }
        });
      })
      },



    addCarousel(file) {

      // let obj = {
      //   url:file,
      // }
      let obj = this.addForm
      addCarousel(obj).then(res => {
        this.$message({
          type: "success",
          message: res.msg,
          duration: 1500,
          onClose: () => {
            this.dialogFormVisible = false
            this.dataSelect()
          }
        });
      })
    },

    deletes(id) {
      let obj = {
        id: id,
      }
      this.$confirm(`确定删除此条信息?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCarousel(obj).then(res => {
          this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.dataSelect()
            }
          });
        })
      }).catch(() => { })
    },

    dataSelect() {
      let post = {
        page: (this.page - 1) * this.size,
        size: this.size
      }
      this.tableDataLoading = true
      getCarouselList(post).then((res) => {
        this.tableDataLoading = false
        if (res.code == 200) {
          // this.tableData = res.data.data;
          res.data.data.forEach(item => {
            // console.log(item.createTime);
            item.createTime = moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')
            // 
          });
          this.tableData = res.data.data
          // console.log('this.tableDatathis.tableData',this.tableData)
          this.totalnum = res.data.count;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      })

    },

    // 添加分类弹框
    addNotice() {
      this.addForm = {
        url: '',
        type: '',
        jumpUrl: '',
        webPage: ''
      }
      this.dialogFormVisible = true
    },

    // 添加分类弹框
    updateNotice(row) {
      this.updateForm = JSON.parse(JSON.stringify(row));
      this.dialogFormVisible1 = true
    },

  }
}
</script>

<style scoped>
.userRole {
  width: 100%;

}
</style>


// WEBPACK FOOTER //
// src/views/manage/carousel/index.vue